import React, { useEffect, useState } from "react";
import "../beratungsfeder.css";
import "./fokusthema.css";
import Immobilienverwaltung from "./Immobilienverwaltung";
import DigitalisierteHausverwaltung from "./DigitalisierteHausverwaltung";
import EbookDownloads from "./EbookDownloads";
import SideIndex from "../../Transformations/SideIndex";
import { Link, useParams } from "react-router-dom";
import Ebook from "./Ebook";
import EbookForms from "../../EbookForms/EbookForms";
import OrgaCheck from "./OrgaCheck";

export default function Fokusthema() {
	const [cont, setCont] = useState(null);

	const [showCont, setShowCont] = useState(0);
	const { subType } = useParams("subType");

	useEffect(() => {
		setCont(subType);
		setShowCont(subType);
	}, [subType]);

	return (
		<div className="beratungsfeder immobil">
			<SideIndex
				setCont={setCont}
				cont={cont}
				name={"fokus"}
				subType={subType ? subType : "Immobilienverwaltung"}
			/>

			<div
				className="beratungsfeder-content"
				onClick={(e) => setShowCont("Immobilienverwaltung")}
			>
				{cont === "Immobilienverwaltung" || cont === null ? (
					<Immobilienverwaltung />
				) : cont === "asset" ? (
					<DigitalisierteHausverwaltung />
				) : cont === "orgacheck" ? (
					<OrgaCheck />
				) : cont === "ebookdownloads" ? (
					<EbookDownloads />
				) : cont === "ebook" ? (
					<EbookForms type="ebook" />
				) : (
					""
				)}
			</div>
			<button
				className="show-kontact"
				onClick={(e) => setShowCont(showCont != 2 ? 2 : 0)}
			>
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="16"
					height="16"
					fill="currentColor"
					className="bi bi-telephone"
					viewBox="0 0 16 16"
				>
					<path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.6 17.6 0 0 0 4.168 6.608 17.6 17.6 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.68.68 0 0 0-.58-.122l-2.19.547a1.75 1.75 0 0 1-1.657-.459L5.482 8.062a1.75 1.75 0 0 1-.46-1.657l.548-2.19a.68.68 0 0 0-.122-.58zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877z" />
				</svg>
			</button>

			<aside className={showCont != 2 ? "contact-sec" : "contact-sec open-sec"}>
				<p className="contact-person">
					<span className="contact-patener">Ansprechpartnerin </span>
					<img src="https://feingeist-beratung.de/wp-content/uploads/2023/12/kristin.jpg" />
					<span>Kristin Aßmann</span>
					<span>Leiterin Immobilienwirtschaft</span>
				</p>
				<p>
					Setzen Sie sich mit uns in Verbindung und lassen Sie sich
					unverbindlich beraten.
				</p>
				<a className="link-button" href="/kontakt">
					Kontaktieren Sie uns
				</a>
				{cont === "orgacheck" ? (
					<div className="book-image py-4 ">
						<a href="https://feingeist-beratung.de/wp-content/uploads/2024/04/Der-Orga-Check-der-Feingeist-Beratung.pdf">
							<img
								className="ebook-img"
								src="https://feingeist-beratung.de/wp-content/uploads/2024/08/Das-Orga-Check-Konzept-der-Feingeist-Beratung.png"
							/>
						</a>
						<p className="text-center w-100 mb-0">Download</p>
						<p className="mt-0">Orga Check-Konzept der Feingeist GmbH</p>
					</div>
				) : (
					""
				)}
			</aside>
		</div>
	);
}
